import { useState } from 'react'
import $ from 'jquery'
import { addCSRF } from 'lib/document_utilities'

const SUBMISSION_STATE = 'managing_agent'

function apiApply(packageHashedId) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `/packages/${packageHashedId}/apply`,
      type: 'POST',
      dataType: 'json',
      data: addCSRF({ state: SUBMISSION_STATE }),
      success: resolve,
      error: (jqXHR) => reject(jqXHR.responseJSON || jqXHR),
    })
  })
}

function apiRevoke(packageHashedId, reason) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `/packages/${packageHashedId}/revoke`,
      type: 'DELETE',
      dataType: 'json',
      data: addCSRF({ state: SUBMISSION_STATE, reason }),
      success: resolve,
      error: reject,
    })
  })
}

function apiCaptureProcessingFees(packageHashedId) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `/packages/${packageHashedId}/capture_fees`,
      type: 'POST',
      dataType: 'json',
      data: addCSRF({ hashed_id: packageHashedId }),
      success: resolve,
      error: reject,
    })
  })
}

function dispatch(name, detail) {
  document.dispatchEvent(new CustomEvent(name, { detail }))
}

// Encapsulates the three server calls of the submission flow and the
// cross-component CustomEvents that replace the old jQuery DOM mutation.
export function usePackageSubmission({ packageHashedId, submittedToManagingAgent, unrevokable }) {
  const [submitted, setSubmitted] = useState(Boolean(submittedToManagingAgent))
  const [revoked, setRevoked] = useState(false)

  const apply = async () => {
    const data = await apiApply(packageHashedId)
    setSubmitted(true)

    if (data.redirect) {
      window.location.href = `/packages/${packageHashedId}/voting`
      return data
    }

    dispatch('packages:submission:applied', {
      state: data.state || SUBMISSION_STATE,
      onlyProcessingDue: Boolean(data.onlyProcessingDue),
    })

    if (data.onlyProcessingDue) {
      await apiCaptureProcessingFees(packageHashedId).catch(() => {})
    }

    return data
  }

  const revoke = async (reason) => {
    const data = await apiRevoke(packageHashedId, reason)
    setSubmitted(false)
    if (unrevokable) setRevoked(true)
    dispatch('packages:submission:revoked', { reason, state: data.state || SUBMISSION_STATE })
    return data
  }

  return {
    submitted,
    revoked,
    apply,
    revoke,
  }
}
